import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import FeatherIcon from "feather-icons-react"

const CtaSection = () => {
    const { t } = useTranslation()

    return (
        <section
            className="section"
            style={{
                background: "linear-gradient(135deg, #1E3A5F 0%, #0D1F33 100%)"
            }}
        >
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title">
                            <h4 className="title text-white mb-4">{t("cta.title")}</h4>
                            <p className="text-white-50 para-desc mx-auto">
                                {t("cta.subtitle")}
                            </p>
                            <div className="mt-4 pt-2">
                                <Link to="/demo" className="btn btn-primary btn-lg">
                                    {t("cta.button")}
                                    <FeatherIcon icon="arrow-right" className="fea icon-sm ms-2" />
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default CtaSection
